import Img9 from '../Assets/forspoken.jpeg'
import Img10 from '../Assets/EvilDead.jpg'
import Img11 from '../Assets/forza.jpg'
import Img12 from '../Assets/grangran.jpg'
import Img13 from '../Assets/steelrising.jpg'
import Img14 from '../Assets/homeworld.jpg'

const Soon = [
    {
        id: 9,
        title:"Forspoken",
        genre: "Action-adventure",
        info: "New",
        price: "pre-ordered",
        img: Img9,
      
    },
    {
        id: 10,
        title:"Evil Dead",
        genre: "Action-adventure",
        info: "New",
        price: "pre-ordered",
        img: Img10,
       
    },
    {
        id: 11,
        title:"Forza Horizon 3",
        genre: "Racing game",
        info: "New",
        img: Img11,
        price: "pre-ordered",

    },
  
    {
        id: 12,
        title:"Gran Turismo 7",
        genre: "Sim racing",
        info: "New",
        img: Img12,
        price: "pre-ordered",

    },
  
    {
        id: 13,
        title:"Steelrising",
        genre: "Role-playing game",
        info: "New",
        img: Img13,
        price: "pre-ordered",

    },
    {
        id: 14,
        title:"Homeworld 3",
        genre: "Space flight simulation game",
        info: "New",
        img: Img14,
        price: "pre-ordered",

    }
]

export default Soon;